const cambridgeThemeVariables = {
    footer__tocButtonIcon: 'fa-list-ul',
    header__optionsAnchorIcon: 'fa-cog',
    header__showMessagesButton: false,
    question__showCopyrightText: true,
    question__showMarksInBrackets: true,
    submit__showSubmitIcon: false,
    toc__showFlaggedText: true,
    toc__tableHeaderOnEachTBody: false,
};

export default cambridgeThemeVariables;
